import * as React from 'react';

import { MAX_SHORT_ANSWER_TEXT_LENGTH } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import { ApplicationState } from 'clients/app/src/rootReducer';
import { useDispatch, useSelector } from 'react-redux';

import { IconButton } from '~shared/components/buttons';
import { IconX } from '~shared/components/icons/standard';
import TextInput from '~shared/components/TextInput';

import { makeSelectIsControlsDisabled } from '../../slices/quiz/quizSelectors';
import { changeAnswerText, deleteAnswer } from '../../slices/quiz/quizSlice';

type Props = {
  answerId: string | number;
};

const QuestionShortAnswerEditAnswer = ({ answerId }: Props) => {
  const answer = useSelector(
    (state: ApplicationState) => state.teachers.quizData.editAnswers[answerId]
  );

  const isControlsDisabled = useSelector(makeSelectIsControlsDisabled());
  const dispatch = useDispatch();

  const handleChangeText = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { id: answerId } = answer;
      const answerText = event.currentTarget.value;
      dispatch(changeAnswerText({ answerId, answerText }));
    },
    [dispatch, answer]
  );
  const handleDeleteAnswer = React.useCallback(() => {
    dispatch(deleteAnswer({ answerId: answer.id }));
  }, [dispatch, answer]);

  const answerLabel = translate('Correct Answer (Optional)');

  return (
    <div className="flex flex-1">
      <div className="flex-1">
        <TextInput
          className="relative z-10 w-full"
          withBorder={false}
          value={answer.text}
          placeholder={answerLabel}
          aria-label={answerLabel}
          disabled={isControlsDisabled}
          onChange={handleChangeText}
          maxLength={MAX_SHORT_ANSWER_TEXT_LENGTH}
        />
      </div>
      <IconButton
        withAltBackground
        appearance="ghost"
        isRisky
        disabled={isControlsDisabled}
        onClick={handleDeleteAnswer}
        aria-label={translate('Remove Answer')}
      >
        <IconX />
      </IconButton>
    </div>
  );
};

export default QuestionShortAnswerEditAnswer;
